import axios from 'axios'
import Moment from 'moment'
import { useEffect, useState } from 'react'
import Calendar from 'react-calendar'
import * as TypIcons from 'react-icons/ti'
import { useParams } from 'react-router'
import { Link, useNavigate } from 'react-router-dom'
import Indicador2 from '../../Components/Dash/indicador2'
import authService from '../../Components/Login/auth.service'
import {
  ContainerPage,
  TitleOfPage,
  TitlePage1,
  TitlePage2
} from '../../Components/Main'
import ProfileDireita from '../../Components/ProfileDireita'
import SidebarMobile from '../../Components/SideBar-right/SidebarMobile'
import '../../styles/components/Calendar.css'
import '../../styles/pages/relatorio.css'

function RelatorioLocal() {
  let id = useParams()
  const dateAtual = new Date()
  if (sessionStorage.DataInicio === undefined) {
    sessionStorage.DataInicio = new Date(
      dateAtual.getFullYear(),
      dateAtual.getMonth(),
      1
    )
    sessionStorage.DataFim = new Date()
  }
  const [date, setDate] = useState([
    Moment(`${sessionStorage.DataInicio} 00:00:00`).isValid()
      ? new Date(`${sessionStorage.DataInicio} 00:00:00`)
      : new Date(sessionStorage.DataInicio),
    Moment(`${sessionStorage.DataFim} 23:59:59`).isValid()
      ? new Date(`${sessionStorage.DataFim} 23:59:59`)
      : new Date(sessionStorage.DataFim)
  ])
  const setSeacrhDate = (e: any) => {
    setDate(e)
    sessionStorage.DataInicio = e[0].toISOString().slice(0, 10)
    e[1].setDate(e[1].getDate() - 1)
    sessionStorage.DataFim = e[1].toISOString().slice(0, 10)
    window.location.reload()
  }
  sessionStorage.visualizacao = 'Dashboard'
  const history = useNavigate()
  var user = authService.getCurrentUser()
  const [auditorias, setAuditorias] = useState<any[]>([])
  const [searchTerm, setSearchTerm] = useState('')
  const [notaMin, setNotaMin] = useState(0)
  const [notaMax, setNotaMax] = useState(11)

  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
          '/api/v1/auditoria/list/' +
          user[0].IdEmpresa +
          '/' +
          sessionStorage.IdUnidade +
          '/' +
          sessionStorage.DataInicio +
          '/' +
          sessionStorage.DataFim
      )
      .then(response => {
        setAuditorias(response.data)
      })
  }, [])
  function handleUnidadeChange(event: any) {
    sessionStorage.visualizacao = event.target.value
    history('/ListagemRelatorio/')
  }
  return (
    <div className="displayInteract">
      <ContainerPage>
        <div id="containerHead1">
          <div className="logo" />
        </div>
        <button
          className="btnReturn"
          type="button"
          onClick={() => history(-1)}
        >
          <TypIcons.TiArrowBackOutline />
        </button>

        <div id="containerHead2">
          <TitleOfPage>
            <TitlePage1>{sessionStorage.uniRazaoSocial} / DASHBOARD</TitlePage1>
            <Link to="/Home">
              <TitlePage2>Auditorias</TitlePage2>
            </Link>
          </TitleOfPage>
          <div id="containerPesquisaModal">
            <input
              className="fnamePadrao"
              placeholder="Filtrar Local"
              type="text"
              id="fname1"
              name="fname"
              onChange={event => {
                setSearchTerm(event.target.value)
              }}
            />
          </div>
        </div>
        <div className="cxLegendaRel1">
          <label htmlFor="" className="lgHLegenda">
            Filtro:
          </label>
          <button
            className="lgHNeutro"
            onClick={event => {
              setNotaMax(11)
              setNotaMin(0)
            }}
          >
            Exibir Todas
          </button>
          <button
            className="lgHAcima"
            onClick={event => {
              setNotaMax(11)
              setNotaMin(7)
            }}
          >
            Acima da Média
          </button>
          <button
            className="lgHMedia"
            onClick={event => {
              setNotaMax(7)
              setNotaMin(3)
            }}
          >
            Média
          </button>
          <button
            className="lgHAbaixo"
            onClick={event => {
              setNotaMax(3)
              setNotaMin(0)
            }}
          >
            Abaixo da Média
          </button>
        </div>
        <div className="tabelaPadrao">
          {auditorias
            .filter(val => {
              if (
                searchTerm === '' &&
                parseInt(val.audNota) >= notaMin &&
                parseInt(val.audNota) < notaMax &&
                val.IdLocalArea === id['IdLocal']
              ) {
                return val
              } else if (
                val.locDescricao
                  .toLowerCase()
                  .includes(searchTerm.toLowerCase()) &&
                parseInt(val.audNota) >= notaMin &&
                parseInt(val.audNota) < notaMax &&
                val.IdLocalArea === id['IdLocal']
              ) {
                return val
              }
            })
            .map(auditoria => (
              //<a href={`http://ws.hitperformance.com.br/Cozinha/RelatorioAuditoria?id=${auditoria.IdRetornoAuditoria}`} target={'_blank'} >
              <a
                        href={`http://cozinhaesaude.hitperformance.com.br/RelatorioAuditoria/${auditoria.audCodigoGUID}`}
                        target={'_blank'}
                      >
                <Indicador2
                  p_resultado={auditoria.audNota}
                  p_restaurante={auditoria.locDescricao}
                  p_data={auditoria.audData}
                  p_cor={
                    parseInt(auditoria.audNota) < 3
                      ? 'red'
                      : parseInt(auditoria.audNota) < 8
                      ? 'yellow'
                      : 'green'
                  }
                />
              </a>
            ))}
        </div>
      </ContainerPage>
      <nav className="esconderFiltro">
        <ProfileDireita />
        <aside className="calendarRelatorio2">
          <form action="">
            <h1 className="selectAnalise">Selecione:</h1>
            <label htmlFor="">Visualização:</label>
            <select
              name="IdUnidade"
              onChange={event => {
                handleUnidadeChange(event)
              }}
            >
              <option
                value={'Dashboard'}
                selected={'Dashboard' === sessionStorage.visualizacao}
              >
                Dashboard
              </option>
              <option
                value={'Listagem'}
                selected={'Listagem' === sessionStorage.visualizacao}
              >
                Listagem
              </option>
            </select>

            <label htmlFor="">Período Selecionado:</label>
            <Calendar
              calendarType="Hebrew"
              onChange={setSeacrhDate}
              defaultValue={date}
              selectRange={true}
            />
          </form>
        </aside>
      </nav>
    </div>
  )
}

export default RelatorioLocal
